import React, { ReactElement } from 'react';

import { FormattedMessage } from 'react-intl';
import makeStyles from '@mui/styles/makeStyles';
import { Card, CardContent, CardMedia, Typography } from '@mui/material';
import { ReactComponent as CollectorErrorIcon } from './icons/Collector_Error_Icon.svg';
import { ReactComponent as ZTTextLogo } from './icons/ZeroTime_TextLogo.svg';

const useStyles = makeStyles((theme) => ({
  errorLogo: {
    display: 'flex',
    justifyContent: 'center'
  },
  ztLogo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  card: {
    width: theme.spacing(53),
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    marginTop: theme.spacing(2)
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    flexDirection: 'column',
    height: '100vh',
    background: '#f5f5f5'
  },
  message: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(4)
  },
  textBold: {
    fontWeight: theme.typography.fontWeightBold
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }
}));

const CollectorInsufficientPermissionsPage = (): ReactElement => {
  const classes = useStyles();

  return (
    <div
      data-testid="collector-insufficient_permissions-page"
      className={classes.container}
    >
      <div
        className={classes.ztLogo}
        data-testid="collector-insufficient_permissions-ztLogo"
      >
        <ZTTextLogo />
      </div>

      <br />
      <Card
        className={classes.card}
        data-testid="collector-insufficient_permissions-error-card"
      >
        <CardMedia
          className={classes.errorLogo}
          data-testid="collector-insufficient_permissions-error-logo"
        >
          <CollectorErrorIcon />
        </CardMedia>
        <CardContent className={classes.message}>
          <Typography
            data-testid="collector-insufficient_permissions-header"
            variant="h4"
          >
            <FormattedMessage id="collectorError.insufficientPermissions" />
          </Typography>
          <br />
          <Typography
            data-testid="collector-insufficient_permissions-description"
            variant="body1"
          >
            <FormattedMessage id="collectorError.insufficientPermissionsDescription" />
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
};

export default CollectorInsufficientPermissionsPage;
